// src/components/SearchBar.js
import React from 'react';
import PropTypes from 'prop-types';
import { Input, InputGroup, InputLeftElement, InputRightElement, IconButton } from '@chakra-ui/react';
import { SearchIcon, CloseIcon } from '@chakra-ui/icons';

const SearchBar = ({ value, onChange, placeholder, onClear, size, width, maxWidth, focusBorderColor, errorBorderColor,searchBgColor,placeholderColor }) => {
  return (
    <InputGroup size={size} width={width} maxWidth={maxWidth}>
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="gray.300" />
      </InputLeftElement>
      <Input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        variant="outline"
        focusBorderColor={focusBorderColor}
        errorBorderColor={errorBorderColor}
        bg={searchBgColor}
        _placeholder={placeholderColor}
      />
      {value && (
        <InputRightElement>
          <IconButton
            aria-label="Clear search"
            icon={<CloseIcon />}
            size={size}
            onClick={onClear}
            variant="ghost"
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onClear: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  height: PropTypes.string, // Height of the search bar
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Width of the search bar
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Maximum width of the search bar
  focusBorderColor: PropTypes.string, // Outline color when focused
  errorBorderColor: PropTypes.string, // Outline color when error
  searchBgColor: PropTypes.string, // Background color when input is not empty
  placeholderColor: PropTypes.object // Placeholder text color
};

SearchBar.defaultProps = {
  placeholder: 'Search...',
  size: 'md',
  height: '10%',
  maxWidth: '600px', // Max width
  focusBorderColor: 'rcBrand.1', // Default focus outline color
  errorBorderColor: 'red.500', // Default error outline color
  searchBgColor: 'white', // Default background color when input is not empty
  placeholderColor: {color:'black'}
};

export default SearchBar;
